import React, { useCallback, useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
interface ProofNotification {
  name: string;
  city: string;
  time: string;
}
const NOTIFICATIONS: ProofNotification[] = [{
  name: 'María G.',
  city: 'Ciudad de México',
  time: 'hace 2 minutos'
}, {
  name: 'Valentina R.',
  city: 'Buenos Aires',
  time: 'hace 5 minutos'
}, {
  name: 'Camila T.',
  city: 'Bogotá',
  time: 'hace 8 minutos'
}, {
  name: 'Lucía M.',
  city: 'Lima',
  time: 'hace 1 minuto'
}, {
  name: 'Andrea S.',
  city: 'Santiago',
  time: 'hace 12 minutos'
}, {
  name: 'Sofía P.',
  city: 'Guadalajara',
  time: 'hace 3 minutos'
}, {
  name: 'Daniela F.',
  city: 'Medellín',
  time: 'hace 7 minutos'
}, {
  name: 'Isabella C.',
  city: 'Monterrey',
  time: 'hace 4 minutos'
}, {
  name: 'Fernanda L.',
  city: 'Miami',
  time: 'hace 6 minutos'
}, {
  name: 'Paola V.',
  city: 'Madrid',
  time: 'hace 9 minutos'
}, {
  name: 'Carolina M.',
  city: 'Quito',
  time: 'hace 2 minutos'
}, {
  name: 'Ana R.',
  city: 'San José',
  time: 'hace 11 minutos'
}, {
  name: 'Mariana G.',
  city: 'Caracas',
  time: 'hace 5 minutos'
}, {
  name: 'Natalia B.',
  city: 'Asunción',
  time: 'hace 3 minutos'
}, {
  name: 'Laura C.',
  city: 'Montevideo',
  time: 'hace 8 minutos'
}, {
  name: 'Gabriela H.',
  city: 'Guadalajara',
  time: 'hace 4 minutos'
}, {
  name: 'Renata S.',
  city: 'São Paulo',
  time: 'hace 6 minutos'
}, {
  name: 'Valeria M.',
  city: 'Caracas',
  time: 'hace 2 minutos'
}, {
  name: 'Jimena R.',
  city: 'La Paz',
  time: 'hace 10 minutos'
}, {
  name: 'Patricia L.',
  city: 'Santo Domingo',
  time: 'hace 5 minutos'
}, {
  name: 'Alejandra V.',
  city: 'Cali',
  time: 'hace 7 minutos'
}, {
  name: 'Mónica T.',
  city: 'Ciudad de Panamá',
  time: 'hace 3 minutos'
}, {
  name: 'Claudia F.',
  city: 'Houston',
  time: 'hace 9 minutos'
}, {
  name: 'Rebeca M.',
  city: 'San Salvador',
  time: 'hace 4 minutos'
}, {
  name: 'Elena P.',
  city: 'Barcelona',
  time: 'hace 6 minutos'
}, {
  name: 'Verónica C.',
  city: 'Tegucigalpa',
  time: 'hace 2 minutos'
}, {
  name: 'Adriana L.',
  city: 'Orlando',
  time: 'hace 8 minutos'
}, {
  name: 'Marcela G.',
  city: 'Rosario',
  time: 'hace 5 minutos'
}, {
  name: 'Karla B.',
  city: 'Puebla',
  time: 'hace 3 minutos'
}, {
  name: 'Diana R.',
  city: 'Guayaquil',
  time: 'hace 7 minutos'
}, {
  name: 'Silvana M.',
  city: 'Córdoba',
  time: 'hace 4 minutos'
}, {
  name: 'Lorena T.',
  city: 'Los Ángeles',
  time: 'hace 11 minutos'
}, {
  name: 'Vanessa C.',
  city: 'Managua',
  time: 'hace 2 minutos'
}, {
  name: 'Estela P.',
  city: 'Asunción',
  time: 'hace 6 minutos'
}, {
  name: 'Rocío F.',
  city: 'Sevilla',
  time: 'hace 9 minutos'
}, {
  name: 'Susana V.',
  city: 'Mérida',
  time: 'hace 3 minutos'
}, {
  name: 'Pilar M.',
  city: 'Nueva York',
  time: 'hace 5 minutos'
}, {
  name: 'Inés G.',
  city: 'Arequipa',
  time: 'hace 7 minutos'
}, {
  name: 'Beatriz R.',
  city: 'Tijuana',
  time: 'hace 4 minutos'
}, {
  name: 'Marisol L.',
  city: 'San Juan',
  time: 'hace 2 minutos'
}];
const INITIAL_DELAY = 8000; // 8s before first toast
const VISIBLE_DURATION = 5000; // 5s visible
const MIN_PAUSE = 5000; // 5s
const MAX_PAUSE = 10000; // 10s
function shuffle<T>(arr: T[]): T[] {
  const copy = [...arr];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
}
function randomPause() {
  return Math.floor(Math.random() * (MAX_PAUSE - MIN_PAUSE + 1)) + MIN_PAUSE;
}
export function SocialProofToast() {
  const [current, setCurrent] = useState<ProofNotification | null>(null);
  const [stickyOffset, setStickyOffset] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  // Queue management
  const queueRef = useRef<ProofNotification[]>([]);
  const lastShownRef = useRef<ProofNotification | null>(null);
  const timeoutRef = useRef<number | null>(null);
  const refillQueue = useCallback(() => {
    let next = shuffle(NOTIFICATIONS);
    // Avoid repeating same notification consecutively across cycles
    if (lastShownRef.current && next[0] === lastShownRef.current && next.length > 1) {
      ;
      [next[0], next[1]] = [next[1], next[0]];
    }
    queueRef.current = next;
  }, []);
  const showNext = useCallback(() => {
    // If modal is open, defer
    if (modalOpen) {
      timeoutRef.current = window.setTimeout(showNext, 1500);
      return;
    }
    if (queueRef.current.length === 0) refillQueue();
    const next = queueRef.current.shift()!;
    lastShownRef.current = next;
    setCurrent(next);
    // Hide after visible duration
    timeoutRef.current = window.setTimeout(() => {
      setCurrent(null);
      // Schedule next
      timeoutRef.current = window.setTimeout(showNext, randomPause());
    }, VISIBLE_DURATION);
  }, [modalOpen, refillQueue]);
  // Kick off the cycle
  useEffect(() => {
    timeoutRef.current = window.setTimeout(showNext, INITIAL_DELAY);
    return () => {
      if (timeoutRef.current) window.clearTimeout(timeoutRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Listen for legal modal open/close to pause/resume
  useEffect(() => {
    const onOpen = () => setModalOpen(true);
    const onClose = () => setModalOpen(false);
    window.addEventListener('legal-modal:open', onOpen);
    window.addEventListener('legal-modal:close', onClose);
    return () => {
      window.removeEventListener('legal-modal:open', onOpen);
      window.removeEventListener('legal-modal:close', onClose);
    };
  }, []);
  // If modal opens while a toast is visible, hide it immediately
  useEffect(() => {
    if (modalOpen && current) setCurrent(null);
  }, [modalOpen, current]);
  // Track if sticky bottom CTA is showing so we shift the toast up
  useEffect(() => {
    const finalCTAId = 'final-cta-section';
    const HERO_THRESHOLD = 600;
    const update = () => {
      const scrolledPastHero = window.scrollY > HERO_THRESHOLD;
      const finalCTA = document.getElementById(finalCTAId);
      let beforeFinalCTA = true;
      if (finalCTA) {
        const rect = finalCTA.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.85) beforeFinalCTA = false;
      }
      setStickyOffset(scrolledPastHero && beforeFinalCTA);
    };
    update();
    window.addEventListener('scroll', update, {
      passive: true
    });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);
  const handleClose = () => {
    if (timeoutRef.current) window.clearTimeout(timeoutRef.current);
    setCurrent(null);
    timeoutRef.current = window.setTimeout(showNext, randomPause());
  };
  return <div aria-live="polite" aria-atomic="true" className="pointer-events-none fixed z-[60] left-3 md:left-5 transition-[bottom] duration-300" style={{
    bottom: stickyOffset ? 88 : 20
  }} data-id="element-288">
      <AnimatePresence data-id="element-289">
        {current && <motion.div key={`${current.name}-${current.city}-${current.time}`} initial={{
        opacity: 0,
        x: -40
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -40
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="pointer-events-auto relative bg-cream border-l-[3px] border-clay rounded-[10px] shadow-[0_12px_30px_-12px_rgba(43,37,32,0.25)] py-3 pl-4 pr-7 w-[85vw] max-w-[280px] md:w-[280px]" role="status" data-id="element-290">
            <button type="button" onClick={handleClose} aria-label="Cerrar notificación" className="absolute top-1.5 right-1.5 text-muted/60 hover:text-ink p-1 rounded-full transition-colors" data-id="element-291">
              <X className="w-3 h-3" data-id="element-292" />
            </button>
            <div className="flex items-start gap-3" data-id="element-293">
              <div className="shrink-0 w-8 h-8 rounded-full bg-clay/10 flex items-center justify-center" data-id="element-294">
                <ShoppingBag className="w-4 h-4 text-clay" data-id="element-295" />
              </div>
              <div className="min-w-0 flex-1" data-id="element-296">
                <p className="text-[13px] leading-snug text-ink" data-id="element-297">
                  <span className="font-bold" data-id="element-298">
                    {current.name} de {current.city}
                  </span>{' '}
                  acaba de comprar{' '}
                  <span className="text-clay font-semibold" data-id="element-299">
                    Apaga Tu Inflamación
                  </span>{' '}
                  <span className="text-sage font-semibold" data-id="element-300">por $9.99 USD</span>
                </p>
                <p className="text-[11px] text-muted/80 mt-1" data-id="element-301">{current.time}</p>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}